import { page as rudderPage, track as rudderTrack } from "../utils/rudderstack";
import { useLandingPageConfig } from "./useLandingPageConfig";

export const useAnalytics = () => {
  const pageConfig = useLandingPageConfig();
  const affiliateDestinations = pageConfig?.affiliateDestinations || [];

  return {
    track: (event: string, properties?: Record<string, any>) => {
      rudderTrack(event, properties, affiliateDestinations);
    },
    page: (
      category?: string,
      name?: string,
      properties?: Record<string, any>,
    ) => {
      rudderPage(category, name, properties, affiliateDestinations);
    },
    affiliateDestinations,
  };
};
